import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from "@material-ui/styles"
import { DialogActions, DialogContent } from '@material-ui/core';

import Button from '@material-ui/core/Button';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import PersonIcon from '@material-ui/icons/Person';
import blue from '@material-ui/core/colors/blue';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles(theme => ({
    chip: {
        margin: theme.spacing(0.1),
        color: 'darkblue',
        cursor: "pointer",
        fontSize:"12px"
    },
    selectedChip: {
        margin: theme.spacing(1),
        color: 'red',
        cursor: "pointer"
    },
    avatar: {
        backgroundColor: blue[100],
        color: blue[600],
    },
}));


function UsersDialog(props) {
    const classes = useStyles();
    const { open, onClose, selectedValues = [], items } = props;
    const [checked, setChecked] = React.useState(selectedValues);
    useEffect(() => {
        setChecked(selectedValues)
    }, [selectedValues])

    function handleClose() {
        onClose(checked);
    }

    function handleListItemClick(value) {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }

        setChecked(newChecked);
    }


    return (
        <Dialog open={open} onClose={handleClose} aria-labelledby="simple-dialog-title">
            <DialogTitle id="simple-dialog-title">Select Student</DialogTitle>
            <DialogContent>
                <List>
                    {items.map((item, index) => (
                        <ListItem button onClick={() => handleListItemClick(item.childid)} key={index}>
                            <Checkbox checked={checked.indexOf(item.childid) !== -1} tabIndex={-1} disableRipple />
                            <ListItemAvatar>
                                <Avatar className={classes.avatar}>
                                    <PersonIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={`${item.firstname} ${item.lastname}`} />
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleClose} color="primary">
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    );
}

UsersDialog.propTypes = {
    onClose: PropTypes.func,
    selectedValue: PropTypes.string,
};

function ChildList(props) {
    const { options, child_mode,  childids,  groupids } = props;
    const classes = useStyles();
    const [invisible, setInvisible] = React.useState(!child_mode.input.value);
    const [open, setOpen] = React.useState(true);
    const [selectedValues, setSelectedValues] = React.useState(childids.input.value);
    const [groupid, setGroupId] = React.useState(groupids)
    const badgeContent = selectedValues ? selectedValues.length : 0

    useEffect(() => {
        
        function resetInput() {
            setSelectedValues([])
            setInvisible(true)
            childids.input.onChange([])
            child_mode.input.onChange(false)
        }
        if (groupid !== groupids) {
            setGroupId(groupids)
            resetInput();
        }

    }, [groupids])

    useEffect(() => {
        if (!childids.input.value) {
            setSelectedValues([])
            setInvisible(true)
        }
    }, [childids])

    function handleClickOpen() {
        setOpen(true);
    }

    const handleClose = value => {
        setOpen(false);
        setSelectedValues(value);
        props.handleClose()
        childids.input.onChange(value)
        if (value.length > 0) {
            setInvisible(false);
            child_mode.input.onChange(true)
        } else {
            setInvisible(true);
            child_mode.input.onChange(false)
        }
    };


    return (
        <>

            <UsersDialog
                items={options}
                selectedValues={selectedValues}
                open={open}
                onClose={handleClose}
            />

        </>
    )
}

export default ChildList
